const accoutsRowClassName = (record) => {
  if(!record.active) return 'is-deactivated';
}

export default accoutsRowClassName;